export const PROPERTY_MATCH = 'property-match';
//# sourceMappingURL=property-match.js.map